import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Show the Application`}</h2>
    <img {...{
      "src": "./../images/demo/image.089.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Open the RobotShop application`}</p>
      <p parentName="blockquote">{`The Link can be found in the `}<strong parentName="p">{`Demo UI`}</strong>{` under `}<strong parentName="p">{`Third-Party`}</strong>{`. Play with the application UI.`}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`In this demo I am the application SRE (Site Reliability Engineer) responsible for an e-commerce website called RobotShop, an online store operated by my company. In the middle of the day (when clients make most of the purchases) I received a slack message on my mobile, alerting me that there is some problem with the site.`}</p>
    <p>{`Let’s verify what’s going on with the RobotShop site. The application is up but displays an error that it cannot get any ratings.`}</p>
    <h2>{`📥 STEP: Verify ratings are not showing`}</h2>
    <img {...{
      "src": "./../images/demo/image.088.png",
      "alt": "image"
    }}></img>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`🚀 `}<u>{`Action`}</u></strong>{`
Open any robot details to show that there are no ratings displayed.`}</p>
    </blockquote>
    <p><strong parentName="p">{`📣 `}<u>{`Narration`}</u></strong></p>
    <p>{`I know that there are many ratings for each of the products that we sell, so when none are displayed, it means that there is a likely problem with `}<inlineCode parentName="p">{`Ratings`}</inlineCode>{` service withing application that may heavily impact client’s purchasing decisions, as well as may be a sign of a wider outage.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      